import { SolicitudValidate } from './../entities/SolicitudValidate.entity';
import { UsuarioOnline } from './../entities/UsuarioOnline.entity';
import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { SessionService } from '../services/session.service';
import { Router } from '@angular/router';
import { Domiciliacion } from '../entities/domiciliacion.entity';
import { Contrato } from '../entities/contrato.entity';
import * as FileSaver from 'file-saver';
import { Respuesta } from '../entities/respuesta.entity';
import { ValidationError, validate } from 'class-validator';
import { CoreService } from '../services/core.service';

@Component({
  selector: 'app-domiciliacionFactura',
  templateUrl: './domiciliacionFactura.component.html'
})
export class DomiciliacionFacturaComponent implements OnInit {

  public nombreSolicitante: string;
  public identificacionsolicitante: string;
  public emailSolicitante: string;
  public telefonoSolicitante: string;
  public nombrePagador: string;
  public tipoIdentidadPagador: string;
  public identificacionPagador: string;
  public nacionalidadPagador: string;
  public paisPagador: string;
  public provinciaPagador: string;
  public poblacionPagador: string;
  public direccionPagador: string;
  public codigoPostalPagador: string;
  public bic: string;
  public iban: string;
  public resultado: Respuesta;

  public datosDomiciliacion: Domiciliacion;
  public usuario: UsuarioOnline;
  public contrato: Contrato;

  public nombrePagadorInputError: boolean;
  public tipoIdentidadPagadorInputError: boolean;
  public identificacionPagadorInputError: boolean;
  public nacionalidadPagadorInputError: boolean;
  public paisPagadorInputError: boolean;
  public provinciaPagadorInputError: boolean;
  public poblacionPagadorInputError: boolean;
  public direccionPagadorInputError: boolean;
  public codigoPostalPagadorInputError: boolean;
  public bicInputError: boolean;
  public ibanInputError: boolean;

  public messageCabecera: string;
  public typeException: number;
  public messageComplet: string;
  public descargaMandato: boolean;
  public direccionSuministro: string;
  public domiciliado: boolean;
  public isEmmasa: Boolean;

  public paises : any[] = [];

  constructor(
    private userService: UserService,
    private sessionService: SessionService,
    private coreService: CoreService,
    private router: Router
  ) { }

  ngOnInit() {
    this.isEmmasa = this.sessionService.isEmmasa;
    if (this.sessionService.isAuthenicated === true) {
      this.paises = this.getCountries();
      this.descargaMandato = false;
      this.clearInputErrors();
      this.nombreSolicitante = this.sessionService.nombre;
      this.identificacionsolicitante = this.sessionService.login;
      this.emailSolicitante = this.sessionService.email;
      this.telefonoSolicitante = this.sessionService.telefono;
      this.contrato = this.sessionService.contratoSelected;
      this.CargarDatosContrato(this.sessionService.contratoSelected);
    } else {
      this.router.navigate(['/']);
    }
  }

  public CargarDatosContrato(contrato: Contrato) {
    this.domiciliado = contrato.PagadorNombre !== undefined && contrato.PagadorNombre.length > 0;
    this.nombrePagador = contrato.PagadorNombre;
    this.tipoIdentidadPagador = contrato.PagadorTipoDoc;
    this.identificacionPagador = contrato.PagadorDocIden;
    this.nacionalidadPagador = contrato.PagadorNacionalidad;
    this.paisPagador = contrato.PagadorNacion;
    this.provinciaPagador = contrato.PagadorProvincia;
    this.poblacionPagador = contrato.PagadorPoblacion;
    this.direccionPagador = contrato.PagadorDireccion;
    this.codigoPostalPagador = contrato.PagadorCpostal;
    this.direccionSuministro = contrato.InmuebleBO.Direccion;
    this.bic = contrato.Bic;
    this.iban = contrato.Iban;
  }

  public enviar($event): void {
    this.CargarDatosEnvio();
    this.clearInputErrors();
    validate(this.cargarDatosValidar(this.contrato)).then(resultadoUsuario => {
      if (resultadoUsuario.length > 0 && this.domiciliado) {
        this.showErrors(resultadoUsuario);
      } else {
        if (document.getElementById('top') !== null)
          document.getElementById('top').scrollIntoView();
        this.userService.domiciliarFactura(this.sessionService.explotacion, this.datosDomiciliacion)
          .then(
            response => this.domicialiacionOnSuccess(response),
            response => this.domicialiacionOnError(response)
          );
      }
    });
  }

  public Descargar() {
    this.userService.descargarMandato(this.sessionService.explotacion, this.datosDomiciliacion)
      .then(
        response => this.mandatoOnSuccess(response),
        response => this.mandatoOnError(response)
      );
  }

  public CargarDatosEnvio() {
    this.datosDomiciliacion = new Domiciliacion();
    this.usuario = new UsuarioOnline();
    this.contrato = new Contrato();

    this.usuario.Nombre = this.nombreSolicitante;
    this.usuario.Login = this.identificacionsolicitante;
    this.usuario.EMail = this.emailSolicitante;
    this.usuario.Telefono1 = this.telefonoSolicitante;

    this.contrato = this.sessionService.contratoSelected;
    this.contrato.PagadorNombre = this.nombrePagador;
    this.contrato.PagadorTipoDoc = this.tipoIdentidadPagador;
    this.contrato.PagadorDocIden = this.identificacionPagador;
    this.contrato.PagadorNacionalidad = this.nacionalidadPagador;
    this.contrato.PagadorNacion = this.paisPagador;
    this.contrato.PagadorProvincia = this.provinciaPagador;
    this.contrato.PagadorPoblacion = this.poblacionPagador;
    this.contrato.PagadorDireccion = this.direccionPagador;
    this.contrato.PagadorCpostal = this.codigoPostalPagador;
    this.contrato.Bic = this.bic;
    this.contrato.Iban = this.iban;

    this.datosDomiciliacion.TipoSolicitud = 'domicBanc';
    this.datosDomiciliacion.Poblacion = this.sessionService.explotacion;
    this.datosDomiciliacion.Contrato = this.contrato;
    this.datosDomiciliacion.UsuarioOnline = this.usuario;
  }

  public domicialiacionOnSuccess(response) {
    if (this.domiciliado) {
      this.messageCabecera = 'Su solicitud, ha sido realizada descargue el mandato para su firma';
      this.typeException = 0;
      if (this.isEmmasa) {
        this.messageComplet = 'Para poder finalizar la nueva domiciliación, precisamos que nos envíe a oficinavirtual@emmasa.es' +
          ' tanto el DNI/CIF del titular de la cuenta bancaria, escaneado, como el mandato firmado';
      } else {
        this.messageComplet = 'La domiciliación se realizará en el momento de recibir el mandato ' +
          'descargado, con su firma en la mayor brevedad posible.';
      }
      this.descargaMandato = true;
      this.Descargar();
    } else {
      this.messageCabecera = 'Su solicitud ha sido realizada ';
      this.typeException = 2;
      this.messageComplet = 'La solicitud baja domiciliación ha sido enviada correctamente.';
    }
  }

  public domicialiacionOnError(response) {
    this.messageCabecera = 'Envio erroneo';
    this.resultado = response;
    if (this.resultado.Ex !== undefined) {
      this.messageComplet = this.resultado.Ex.Message;
      this.typeException = this.resultado.TipoExcepcion;
    } else {
      this.typeException = 1;
      this.messageComplet = 'El proceso no se ha realizado correctamente. Intentelo de nuevo en unos minutos';
    }
  }

  public recibirContrato(event): void {
    const contratoSelect: Contrato = event.contratoSeleccionado;
    this.CargarDatosContrato(contratoSelect);
    this.clearInputErrors();
  }

  public mandatoOnSuccess(response) {
    if (this.domiciliado) {
      let fichero: Blob = response;
      let filename = 'mandato.pdf';
      FileSaver.saveAs(fichero, filename);
      this.messageCabecera = 'Su solicitud ha sido realizada';
      this.typeException = 0;
      if (this.isEmmasa) {
        this.messageComplet = 'Para poder finalizar la nueva domiciliación, precisamos que nos envíe a oficinavirtual@emmasa.es' +
          ' tanto el DNI/CIF del titular de la cuenta bancaria, escaneado, como el mandato firmado';
      } else {
        this.messageComplet = 'La domiciliación se realizará en el momento de recibir firmado el mandato en la mayor brevedad posible.';
      }
    } else {
      this.messageCabecera = 'Su solicitud ha sido enviada';
      this.typeException = 2;
      this.messageComplet = 'La solicitud baja domiciliación ha sido enviada correctamente.';
    }
  }

  public mandatoOnError(response) {
    this.messageCabecera = 'Envio erroneo';
    this.resultado = response;
    if (this.resultado.Ex !== undefined) {
      this.messageComplet = this.resultado.Ex.Message;
      this.typeException = this.resultado.TipoExcepcion;
    } else {
      this.typeException = 1;
      this.messageComplet = this.domiciliado ? 'El mandato no se ha generado. Intentelo de nuevo en unos minutos' :
        'La solicitud no se ha podido enviar, intentelo en unos minutos';
    }
  }

  public showErrors(resultado: ValidationError[]) {
    for (let item of resultado) {
      switch (item.property) {
        case 'Nombre':
          this.nombrePagadorInputError = true;
          break;
        case 'TipoDoc':
          this.tipoIdentidadPagadorInputError = true;
          break;
        case 'DocIden':
          this.identificacionPagadorInputError = true;
          break;
        case 'Nacionalidad':
          this.nacionalidadPagadorInputError = true;
          break;
        case 'Nacion':
          this.paisPagadorInputError = true;
          break;
        case 'Provincia':
          this.provinciaPagadorInputError = true;
          break;
        case 'Poblacion':
          this.poblacionPagadorInputError = true;
          break;
        case 'Cpostal':
          this.codigoPostalPagadorInputError = true;
          break;
        case 'Direccion':
          this.direccionPagadorInputError = true;
          break;
        case 'Bic':
          this.bicInputError = true;
          break;
        case 'Iban':
          this.ibanInputError = true;
          break;
      }
    }
  }

  public clearInputErrors() {
    this.nombrePagadorInputError = false;
    this.tipoIdentidadPagadorInputError = false;
    this.identificacionPagadorInputError = false;
    this.nacionalidadPagadorInputError = false;
    this.paisPagadorInputError = false;
    this.provinciaPagadorInputError = false;
    this.poblacionPagadorInputError = false;
    this.direccionPagadorInputError = false;
    this.codigoPostalPagadorInputError = false;
    this.bicInputError = false;
    this.ibanInputError = false;
    this.messageCabecera = '';
    this.messageComplet = '';
    this.typeException = -1;
  }

  public cargarDatosValidar(contrato: Contrato): SolicitudValidate {
    const datosValidar = new SolicitudValidate();
    if (this.domiciliado) {
      datosValidar.Nombre = contrato.PagadorNombre;
      datosValidar.TipoDoc = contrato.PagadorTipoDoc;
      datosValidar.DocIden = contrato.PagadorDocIden;
      datosValidar.Nacionalidad = contrato.PagadorNacionalidad;
      datosValidar.Nacion = contrato.PagadorNacion;
      datosValidar.Provincia = contrato.PagadorProvincia;
      datosValidar.Poblacion = contrato.PagadorPoblacion;
      datosValidar.Direccion = contrato.PagadorDireccion;
      datosValidar.Cpostal = contrato.PagadorCpostal;
      datosValidar.Bic = contrato.Bic;
      datosValidar.Iban = contrato.Iban;
    }
    return datosValidar;
  }

  public Domiciliar() {
    if (!this.domiciliado) {
      this.nombrePagador = '';
      this.tipoIdentidadPagador = '';
      this.identificacionPagador = '';
      this.nacionalidadPagador = '';
      this.paisPagador = '';
      this.provinciaPagador = '';
      this.poblacionPagador = '';
      this.direccionPagador = '';
      this.codigoPostalPagador = '';
      this.direccionSuministro = '';
      this.bic = '';
      this.iban = '';
    } else {
      this.CargarDatosContrato(this.sessionService.contratoSelected);
      this._showDomiciliado = true;
    }
  }

  public Rellenar() {
    this.domiciliado = true;
  }

  public getCountries() {
    return this.coreService.getCountries();
  }

  // MODAL

  _showDomiciliado = false;

  showModal() {
    return this._showDomiciliado;
  }

  closeModal() {
    this._showDomiciliado = false;
  }
}
